import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPersonWarningIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7.668 10.8q.106-.631.37-1.2H6.403a3.2 3.2 0 0 0-2.963 1.99A5.2 5.2 0 0 1 7.202 2.8c2.46 0 4.52 1.708 5.063 4.003q.069-.004.138-.003c.382 0 .755.045 1.11.13A6.4 6.4 0 0 0 .803 8a6.397 6.397 0 0 0 7.617 6.285 4.8 4.8 0 0 1-.56-1.125 5.2 5.2 0 0 1-3.42-.75 2 2 0 0 1 1.963-1.607H7.67zM7.2 7.6a1 1 0 1 1 0-2 1 1 0 0 1 0 2M5 6.6a2.2 2.2 0 1 0 4.4 0 2.2 2.2 0 0 0-4.4 0m7.4 8.6a3.6 3.6 0 0 0 0-7.2 3.6 3.6 0 0 0 0 7.2m0-2.5c.275 0 .5.225.5.5s-.225.5-.5.5a.5.5 0 0 1-.5-.5c0-.275.225-.5.5-.5m0-3.5c.22 0 .4.18.4.4v2c0 .22-.18.4-.4.4s-.4-.18-.4-.4v-2c0-.22.18-.4.4-.4" })
});
export default SvgPersonWarningIcon;
